<template>
  <div class="rt-users-table">
    <el-table
      :data="props.users"
      style="width: 100%"
      size="small"
      border
      empty-text="No data"
      highlight-current-row
      :cell-class-name="cellGrayWhiteOnline"
      class="rt-table"
    >
      <el-table-column
        prop="loginName"
        label="LoginName"
        align="left"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="nickName"
        label="NickName"
        align="left"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        label="Ongoing Chats"
        align="center"
        width="150"
      >
        <template #default="scope">
          <span class="num-cell">{{ scope.row.currentDialog }} / {{ scope.row.dialogMax }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Status"
        align="center"
        width="110"
      >
        <template #default="scope">
          <el-tag
            :type="agentTagType(scope.row.status)"
            size="small"
            effect="light"
          >
            {{ scope.row.status || '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Online Time"
        header-align="right"
        align="right"
        min-width="110"
      >
        <template #default="scope">
          <span
            class="num-cell"
            :title="(scope.row.onlineSeconds || 0) + 's'"
          >{{ showDateTime(scope.row.onlineSeconds) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Away Time"
        header-align="right"
        align="right"
        min-width="110"
      >
        <template #default="scope">
          <span
            class="num-cell"
            :title="(scope.row.awaySeconds || 0) + 's'"
          >{{ showDateTime(scope.row.awaySeconds) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Offline Time"
        header-align="right"
        align="right"
        min-width="110"
      >
        <template #default="scope">
          <span
            class="num-cell"
            :title="(scope.row.offlineSeconds || 0) + 's'"
          >{{ showDateTime(scope.row.offlineSeconds) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { showDateTime } from '@/utils/util'
import { cellGrayWhiteOnline } from '@/utils/style'

const props = defineProps({
  users: {
    type: Array,
    default: () => {
      return [];
    },
  },
})

function agentTagType(s) {
  if (s === 'ONLINE') return 'success'
  if (s === 'AWAY') return 'warning'
  return 'danger'
}
</script>

<style scoped>
.rt-users-table {
  width: 100%;
}
.rt-table :deep(thead th) {
  background: #f5f7fa;
  font-weight: 600;
  color: var(--el-text-color-primary, #303133);
}
.num-cell {
  font-variant-numeric: tabular-nums;
}
</style>
